import { Cell } from '@pelckmans/elementis/components/table';
import classNames from 'classnames';
import React, { forwardRef, useContext, useEffect } from 'react';
import HorizontalScrollContext from '../../../../../shared-components/table/context/HorizontalScrollContext';
import { TableData } from '../types';
import TableGroup from './TableGroup';

interface ResultsTableProps {
  data: TableData;
  detailView: boolean;
  cellHeaderActions: React.ReactNode;
  id: string;
}

const ResultsTable = forwardRef<HTMLTableElement, ResultsTableProps>((props, ref) => {
  const { validateHorizontalOverflow } = useContext(HorizontalScrollContext);

  useEffect(() => {
    validateHorizontalOverflow();
  }, [validateHorizontalOverflow]);

  return (
    <table
      className={classNames('results-table', {
        multiple: !props.detailView,
        single: props.detailView,
      })}
      ref={ref}
      aria-labelledby={props.id}
    >
      <thead>
        <tr>
          <Cell.HeaderText
            className="scorable-item-column"
            title={props.data.header.title}
            sticky
            minWidth="xl"
            maxWidth={props.detailView ? 'xl' : undefined}
          >
            <Cell.HeaderText.Actions>{props.cellHeaderActions}</Cell.HeaderText.Actions>
          </Cell.HeaderText>
          {props.data.header.columns.map(col =>
            col.href ? (
              <Cell.HeaderLink
                className="student-column"
                key={col.id}
                title={col.title}
                linkProps={{ to: col.href }}
                tooltipProps={col.tooltipChildren ? { children: col.tooltipChildren } : undefined}
                sticky
                minWidth={col.minWidth}
                maxWidth={col.maxWidth}
              />
            ) : (
              <Cell.HeaderText
                className="student-column"
                key={col.id}
                title={col.title}
                tooltipProps={col.tooltipChildren ? { children: col.tooltipChildren } : undefined}
                sticky
                minWidth={col.minWidth}
                maxWidth={col.maxWidth}
              />
            ),
          )}
        </tr>
      </thead>
      {props.data.rows.map(row => (
        <TableGroup row={row} key={row.id} detailView={props.detailView} />
      ))}
    </table>
  );
});

export default ResultsTable;
